export default __webpack_public_path__ + "static/media/iphone_xr.873ce2c6.svg";